module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter2"
  }, [_vm._v("A Terrible Loss")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Book1/images/Baum-LostPrincess-scan009.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "chapter1"
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There could be no doubt of the fact: Princess Ozma, the lovely girl ruler of the Fairyland of Oz, was lost. She had completely disappeared. Not one of her subjects—not even her closest friends—knew what had become of her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was Dorothy who first discovered it. Dorothy was a little Kansas girl who had come to the Land of Oz to live and had been given a delightful suite of rooms in Ozma’s royal palace, just because Ozma loved Dorothy and wanted her to live as near her as possible, so the two girls might be much together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dorothy was not the only girl from the outside world who had been welcomed to Oz and lived in the royal palace. There was another named Betsy Bobbin, whose adventures had led her to seek refuge with Ozma, and still another named Trot, who had been invited, together with her faithful companion, Cap’n Bill, to make her home in this wonderful fairyland. The"), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v(" three girls all had rooms in the palace and were great churns; but Dorothy was the dearest friend of their gracious Ruler and only she at any hour dared to seek Ozma in her royal apartments. For Dorothy had lived in Oz much longer than the other girls and had been made a Princess of the realm.")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Betsy was a year older than Dorothy and Trot was a year younger, yet the three were near enough of an age to become great playmates and to have nice times together. It was while the three were talking together one morning in Dorothy’s room that Betsy proposed they make a journey into the Munchkin Country, which was one of the four great countries of the Land of Oz ruled by Ozma.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve never been there yet,” said Betsy Bobbin, “but the Scarecrow once told me it is the prettiest country in all Oz.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d like to go, too,” added Trot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right,” said Dorothy, “I’ll go and ask Ozma. Perhaps she will let us take the Sawhorse and the Red Wagon, which would be much nicer for us than having to walk all the way. This Land of Oz is a pretty big place, when you get to all the edges of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So she jumped up and went along the halls of the splendid palace until she came to the royal suite, which filled all the front of the second floor. In a little waiting room sat Ozma’s maid, Jellia Jamb, who was busily sewing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is Ozma up yet?” inquired Dorothy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know, my dear,” replied Jellia. “I haven’t heard a word from her this morning. She hasn’t even called for her bath or her breakfast, and it is far past her usual time for them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s strange!” exclaimed the little girl.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("“Yes,” agreed the maid; “but of course no harm could have happened to her. No one can die or be killed in the Land of Oz and Ozma is herself a powerful fairy, and she has no enemies, so far as we know. Therefore I am not at all worried about her, though I must admit her silence is unusual.”")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Book1/images/Baum-LostPrincess-scan010.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perhaps,” said Dorothy, thoughtfully, “she has overslept. Or she may be reading, or working out some new sort of magic to do good to her people.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Any of these things may be true,” replied Jellia Jamb, “so I haven’t dared disturb our royal mistress. You, however, are a privileged character, Princess, and I am sure that Ozma wouldn’t mind at all if you went in to see her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course not,” said Dorothy, and opening the door of the outer chamber she went in. All was still here. She walked into another room, which was Ozma’s boudoir, and then, pushing back a heavy drapery richly broidered with threads of pure gold, the girl entered the sleeping-room of the fairy Ruler of Oz. The bed of ivory and gold was vacant; the room was vacant; not a trace of Ozma was to be found.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Very much surprised, yet still with no fear that anything had happened to her friend, Dorothy returned through the boudoir to the other rooms of the suite. She went into the music room, the library, the laboratory, the bath, the wardrobe and even into the great throne room, which adjoined the royal suite, but in none of these places could she find Ozma.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So she returned to the anteroom where she had left the maid, Jellia Jamb, and said:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She isn’t in her rooms now, so she must have gone out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t understand how she could do that without my seeing her,” replied Jellia, “unless she made herself invisible.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She isn’t there, anyhow,” declared Dorothy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then let us go find her,” suggested the maid, who appeared to be a little uneasy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So they went into the corridors and there Dorothy almost stumbled over a queer girl who was dancing lightly along the passage.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("“Stop a minute, Scraps!” she called. “Have you seen Ozma this morning?”")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Book1/images/Baum-LostPrincess-scan011.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Book1/images/Baum-LostPrincess-scan012.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not I!” replied the queer girl, dancing nearer. “I lost both my eyes in a tussle with the Woozy, last night, for the creature scraped’em both off my face with his square paws. So I put the eyes in my pocket and this morning Button-Bright led me to Aunt Em, who sewed’em on again. So I’ve seen nothing at all to-day, except during the last five minutes. So of course I haven’t seen Ozma.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Very well, Scraps,” said Dorothy, looking curiously at the eyes, which were merely two round black buttons sewed upon the girl’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were other things about Scraps that would have seemed curious to one seeing her for the first time. She was commonly called “The Patchwork Girl,” because her body and limbs were made from a gay-colored patchwork quilt which had been cut into shape and stuffed with cotton. Her head was a round ball stuffed in the same manner and fastened to her shoulders. For hair she had a mass of brown yarn and to make a nose for her a part of the cloth had been pulled out into the shape of a knob and tied with a string to hold it in place. Her mouth had been carefully made by cutting a slit in the proper place and lining it with red silk, adding two rows of pearls for teeth and a bit of red flannel for a tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In spite of this queer make-up, the Patchwork Girl was magically alive and had proved herself not the least jolly and agreeable of the many quaint characters who inhabit the astonishing Fairyland of Oz. Indeed, Scraps was a general favorite, although she was rather flighty and erratic and did and said many things that surprised her friends. She was seldom still, hut loved to dance, to turn handsprings and somersaults, to climb trees and to indulge in many other active sports.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m going to search for Ozma,” remarked Dorothy, “for she isn’t in her rooms and I want to ask her a question.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("“I’ll go with you,” said Scraps, “for my eyes are brighter than yours and they can see farther.”")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not sure of that,” returned Dorothy. “But come along, if you like.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Together they searched all through the great palace and even to the farthest limits of the palace grounds, which were quite extensive, but nowhere could they find a trace of Ozma. When Dorothy returned to where Betsy and Trot awaited her, the little girl’s face was rather solemn and troubled, for never before had Ozma gone away without telling her friends where she was going, or without an escort that befitted her royal state.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was gone, however, and none had seen her go. Dorothy had met and questioned the Scarecrow, Tik-Tok, the Shaggy Man, Button-Bright, Cap’n Bill, and even the wise and powerful Wizard of Oz, but not one of them had seen Ozma since she parted with her friends the evening before and had gone to her own rooms.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She didn’t say anything las’ night about going anywhere,” observed little Trot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, and that’s the strange part of it,” replied Dorothy. “Usually Ozma lets us know of everything she does.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not look in the Magic Picture?” suggested Betsy Bobbin. “That will tell us where she is, in just one second.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course!” cried Dorothy. “Why didn’t I think of that before?” and at once the three girls hurried away to Ozma’s boudoir, where the Magic Picture always hung.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("This wonderful Magic Picture was one of the royal Ozma’s greatest treasures. There was a large gold frame, in the center of which was a bluish-gray canvas on which various scenes constantly appeared and disappeared. If one who stood before it wished to see what any person—anywhere in the world—was doing, it was only necessary to make the wish and the scene in the Magic Picture would shift to the scene where that person was and show exactly what he or she was then engaged in doing. So the girls knew it would be easy for them to wish to see Ozma, and from the picture they could quickly learn where she was.")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Book1/images/Baum-LostPrincess-scan013.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dorothy advanced to the place where the picture was usually protected by thick satin curtains, and pulled the draperies aside. Then she stared in amazement, while her two friends uttered exclamations of disappointment.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("The Magic Picture was gone. Only a blank space on the wall behind the curtains showed where it had formerly hung.")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "Book1/images/Baum-LostPrincess-scan014.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa09252c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/xhtml/05_Chapter_1.vue
// module id = 78
// module chunks = 0